import Base from 'app/models/selection';

export default Base.extend({
  getSrc() {
    return this.get('currentChoice').src;
  },
});



// WEBPACK FOOTER //
// ./app/models/image_selection.js